import { create } from 'jsondiffpatch';
import * as jsondiffpatchHtml from 'jsondiffpatch/lib/formatters/html';
import { diffWords } from 'diff';

export async function objectsDiffAsHtml(obj1, obj2) {
  const prepareForComparison = item => {
    delete item.id;
    delete item.serves;
    delete item.params;
    delete item.isPreview;
    delete item.libraryType;
    delete item.createdBy;
    delete item.createdAt;
    delete item.updatedBy;
    delete item.updatedAt;
    delete item.version;
    delete item.isDeleted;

    if (item.template.chain) {
      item.template.chain.forEach(link => {
        link.messages?.forEach((message, index) => {
          message.index = index;
          message.parentId = link.id;
        });
      });
    }
  };

  prepareForComparison(obj1);
  prepareForComparison(obj2);

  const instance = create({
    matchByPosition: true,
    arrays: {
      detectMove: true,
      includeValueOnMove: true
    },
    objectHash: function(obj) {
      if (obj.role) {
        obj.hash = obj.role + '_' + obj.index + '_' + obj.parentId;
        return obj.role + '_' + obj.index + '_' + obj.parentId;
      }

      return obj.id || obj.name || obj.hash || JSON.stringify(obj);
    },
    textDiff: {
      minLength: 1
    }
  });

  const delta = instance.diff(obj1, obj2);

  const replacements = [];

  async function hashString(message) {
    // Encode the string as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // Hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

    return hashHex;
  }

  var diffContent = async object => {
    const promises = !object
      ? [Promise.resolve()]
      : Object.getOwnPropertyNames(object).map(async prop => {
          if (['content', 'title', 'name', 'template', 'query', 'label', 'value'].includes(prop)) {
            if (
              !object[prop] ||
              !Array.isArray(object[prop]) ||
              object[prop].length !== 2 ||
              typeof object[prop][0] !== 'string' ||
              typeof object[prop][1] !== 'string'
            ) {
              return diffContent(object[prop]);
            }

            const left = object[prop][1];
            const right = object[prop][0];

            const before = diffWords(left, right);
            const after = diffWords(right, left);

            let beforeValue = '';
            let afterValue = '';

            before.forEach(val => {
              if (val.added) {
                beforeValue += `<span class='added'>${val.value}</span>`;
              } else if (val.removed) {
                beforeValue += `<span class='deleted'>${val.value}</span>`;
              } else {
                beforeValue += `<span>${val.value}</span>`;
              }
            });

            after.forEach(val => {
              if (val.added) {
                afterValue += `<span class='added'>${val.value}</span>`;
              } else if (val.removed) {
                afterValue += `<span class='deleted'>${val.value}</span>`;
              } else {
                afterValue += `<span>${val.value}</span>`;
              }
            });

            const idLeft = await hashString(left);
            const idRight = await hashString(right);
            object[prop][0] = idLeft;
            object[prop][1] = idRight;

            replacements.push({
              what: object[prop][0],
              with: `<div class='content-dif hidden'><span>"</span>${beforeValue}<span>"</span></div>`
            });
            replacements.push({
              what: object[prop][1],
              with: `<div class='content-dif'><span>"</span>${afterValue}<span>"</span></div>`
            });
          }

          if (typeof object[prop] === 'object' && object[prop]) {
            return diffContent(object[prop]);
          }
        });

    return Promise.all(promises);
  };

  await diffContent(delta);

  let html = delta ? jsondiffpatchHtml.format(delta, obj1) : 'Versions are equal';
  replacements.forEach(rep => {
    html = html.replaceAll(`<pre>&quot;${rep.what}&quot;</pre>`, rep.with);
  });

  return html;
}
